import { Controller } from '@hotwired/stimulus'
import { i18n } from 'config/translations'

export default class extends Controller {
  static targets = ['form']
  static values = { code: String, amount: String }
  connect() {}

  firstFocusAction(firstFocus, element) {
    if (!firstFocus) {
      firstFocus = true
      element.scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center',
      })
    }
    return firstFocus
  }

  addCommas(number) {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  copy(event) {
    const text = i18n.t('referral_code.copied_text', {
      code_value: this.codeValue,
      amount_value: this.addCommas(this.amountValue),
    })
    navigator.clipboard.writeText(text)
    const self = this
    setTimeout(function () {
      self.formTarget.click()
    }, 1200)
  }

  validateForm(event) {
    event.preventDefault()
    let isValid = true
    this.formTarget.querySelectorAll('.validation-warning').forEach((e) => e.remove())
    this.formTarget.querySelectorAll('.text-validation-warning').forEach((e) => e.classList.remove('text-red-600'))
    this.formTarget
      .querySelectorAll('.element-validation-warning')
      .forEach((e) => e.classList.remove('border-red-600', 'bg-red-50'))

    let firstFocus = false
    const requiredFields = this.formTarget.querySelectorAll('textarea.required, input.required, select.required')
    requiredFields.forEach((field) => {
      // For each required field, check to see if the value is empty
      // if so, we focus the field and set our value to false
      if (!field.disabled && !field.value.trim()) {
        field.classList.add('element-validation-warning', 'border-red-600', 'bg-red-50')
        const warningNode = document.createElement('p')
        warningNode.classList.add('mt-2', 'validation-warning', 'text-red-600', 'text-sm')
        const fieldName = field.getAttribute('data-validation-name')
        if (field.tagName === 'INPUT') {
          warningNode.textContent = i18n.t('message.error.input.enter', { field_name: fieldName })
        }

        field.parentNode.insertBefore(warningNode, field.nextSibling)
        if (!field.classList.contains('email')) {
          field.previousElementSibling.classList.add('text-validation-warning', 'text-red-600')
        } else {
          field.previousElementSibling.previousElementSibling.classList.add('text-validation-warning', 'text-red-600')
        }
        isValid = false
        firstFocus = this.firstFocusAction(firstFocus, field)
      }
    })

    const emailFields = this.formTarget.querySelectorAll('input.email')
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    emailFields.forEach((field) => {
      if (field.value.trim() && !field.value.match(validRegex)) {
        field.classList.add('element-validation-warning', 'border-red-600', 'bg-red-50')
        const warningNode = document.createElement('p')
        warningNode.classList.add('mt-2', 'validation-warning', 'text-red-600', 'text-sm')
        const fieldName = field.getAttribute('data-validation-name')
        warningNode.textContent = i18n.t('message.error.input.valid_enter', { field_name: fieldName })
        field.parentNode.insertBefore(warningNode, field.nextSibling)
        field.previousElementSibling.previousElementSibling.classList.add('text-validation-warning', 'text-red-600')
        isValid = false
        firstFocus = this.firstFocusAction(firstFocus, field)
      }
    })

    if (!isValid) {
      return
    }
    this.formTarget.submit()
  }
}
